<template>
  <v-card outlined rounded>
    <v-card-title class="py-4 text-center" v-if="logo">
      <v-spacer />
      <v-sheet rounded outlined>
        <v-responsive class="align-center" :aspect-ratio="1/1">
          <v-sheet class="px-1" width="100">
            <v-img :src="logo.split(/[?#]/)[0]" width="100%" />
          </v-sheet>
        </v-responsive>
      </v-sheet>
      <v-spacer />
    </v-card-title>
    <v-card-subtitle class="py-4">
      <v-row>
        <v-col class="text-center" cols="12">
          <span class="d-block body-1 text--secondary font-weight-medium">{{instance.description}}</span>
          <span class="d-block body-2 text--secondary font-weight-medium">{{account.name}} <template v-if="instance.customer">para {{instance.customer.name}}</template></span>
          <span class="d-block text-h6 text--secondary font-weight-medium" v-if="instance.status !== 'succeeded'">{{instance.amount | currency(instance.currency)}} {{instance.currency}} del {{instance.date | date}}</span>
        </v-col>
      </v-row>
    </v-card-subtitle>
    <v-divider />
    <v-card-text class="px-0 background">
      <template v-if="instance.status === 'succeeded'">
        <v-col class="pt-6 text-center">
          <v-icon large color="primary">mdi-checkbox-marked-circle</v-icon>
          <span class="d-block mt-4 subtitle-1 primary--text font-weight-medium">{{instance.invoice ? 'Factura pagada' : 'Pagado'}}</span>
          <span class="d-block mb-6 subtitle-1 text--secondary font-weight-medium">Pago de {{instance.amount | number}} {{instance.currency}} el {{instance.date | date}}</span>
          <v-btn @click="dialogVoucher=true" outlined color="secondary">Comprobante de pago</v-btn>
        </v-col>
      </template>
      <template v-else>
        <template v-if="method === null">
          <v-col class="pt-6 text-center">
            <v-icon color="red" large>mdi-alert</v-icon>
            <span class="d-block mt-2 text-h6 red--text font-weight-medium">No hay métodos de pago disponibles</span>
            <span class="d-block">Contacta a {{account.name}} para coordinar la forma de pago</span>
          </v-col>
        </template>
        <template v-else>
          <v-row class="px-4" no-gutters>
            <v-col cols="12" class="pt-1 pb-5 text-center">
              <span class="d-block body-2">Elige cómo quieres pagar</span>
            </v-col>
            <v-col cols="12">
              <v-card>
                <v-tabs v-model="method" :color="colorBackground ? colorBackground : account.color_background" background-color="background" fixed-tabs height="55" slider-size="4">
                  <v-tab class="text-none font-weight-medium" :disabled="!instance.gateways.length"><v-icon left small>mdi-credit-card</v-icon>Pago online</v-tab>
                  <v-tab class="text-none font-weight-medium" :disabled="!account.display_bank_statement || !account.bank_statement"><v-icon left small>mdi-bank</v-icon>Transferencia</v-tab>
                </v-tabs>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-tabs-items class="transparent" v-model="method">
                <v-tab-item>
                  <v-row class="mx-0" align="center" justify="start" no-gutters>
                    <v-col cols="12" class="px-0">
                      <v-radio-group class="mt-1 mb-2" v-model="selectedGateway" hide-details>
                        <v-sheet class="overflow-hidden rounded my-2" v-for="gateway in instance.gateways" :key="gateway" outlined>
                          <v-radio class="pl-3 pr-8 py-3" :value="gateway" :color="colorBackground ? colorBackground : account.color_background">
                            <template v-slot:label>
                              <v-row class="pl-3" align="center" justify="space-between">
                                <img class="ml-4" :src="require(`@/assets/appAsset-brand--${gateway}.svg`)" :alt="gateway" height="28">
                              </v-row>
                            </template>
                          </v-radio>
                        </v-sheet>
                      </v-radio-group>
                    </v-col>
                    <v-col cols="12" class="px-0" v-if="selectedGateway">
                      <v-btn :color="colorBackground ? colorBackground : account.color_background" dark height="40" block>Continuar</v-btn>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item>
                  <v-row class="mx-0" align="center" justify="start">
                    <v-col cols="12" class="px-0">
                      <v-sheet class="overflow-hidden rounded mt-4 mb-2" outlined>
                        <pre class="pa-5" v-html="account.bank_statement"></pre>
                      </v-sheet>
                    </v-col>
                  </v-row>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </template>
      </template>
      <template v-if="instance.invoice">
        <v-toolbar class="mt-5 transparent" flat height="50">
          <v-toolbar-title class="subtitle-2 text--secondary font-weight-medium">Detalle {{instance.invoice.document.name}} Nº {{instance.invoice.number}}</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th>Descripción</th>
                <th class="text-right">Cantidad</th>
                <th class="text-right">Precio</th>
                <th class="text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(d, i) in instance.invoice.lines">
                <tr :key="i">
                  <td><span class="text--secondary font-weight-medium">{{d.name}}</span></td>
                  <td class="text-right">{{d.quantity | number}}</td>
                  <td class="text-right"><span class="text--secondary font-weight-medium">{{d.amount | number}}</span></td>
                  <td class="text-right"><span class="body-2 text--secondary font-weight-medium">{{d.total | number}}</span></td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-simple-table>
        <v-divider />
        <!-- summary -->
        <v-row align="center" justify="end">
          <v-col cols="8">
            <v-list class="v-list-form pa-0 transparent">
              <v-list-item>
                <v-list-item-title class="mr-2 text--secondary font-weight-medium">Subtotal</v-list-item-title>
                <v-list-item-subtitle class="text-right">{{instance.invoice.subtotal | currency(instance.invoice.currency)}}</v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-list-item-title class="mr-2 text--secondary font-weight-medium">Descuento</v-list-item-title>
                <v-list-item-subtitle class="text-right">{{instance.invoice.discount | number}} {{instance.invoice.discount_scheme}}</v-list-item-subtitle>
              </v-list-item>
              <template v-if="instance.invoice.document.has_taxes_detail">
                <v-divider class="ml-4 my-2" />
                <v-list-item>
                  <v-list-item-title class="mr-2 text--secondary font-weight-medium">Exento</v-list-item-title>
                  <v-list-item-subtitle class="text-right">{{instance.invoice.exempt | currency(instance.invoice.currency)}}</v-list-item-subtitle>
                </v-list-item>
                <template v-if="instance.invoice.document.has_taxes">
                  <v-list-item>
                    <v-list-item-title class="mr-2 text--secondary font-weight-medium">Neto</v-list-item-title>
                    <v-list-item-subtitle class="text-right">{{instance.invoice.amount | currency(instance.invoice.currency)}}</v-list-item-subtitle>
                  </v-list-item>
                  <v-divider class="ml-4 my-2" />
                  <v-list-item>
                    <v-list-item-title class="mr-2 text--secondary font-weight-medium">Impuestos ({{instance.invoice.tax_percent}}%)</v-list-item-title>
                    <v-list-item-subtitle class="text-right">{{instance.invoice.tax | currency(instance.invoice.currency)}}</v-list-item-subtitle>
                  </v-list-item>
                </template>
              </template>
              <v-divider class="ml-4 my-2" />
              <v-list-item>
                <v-list-item-title class="subtitle-1 text--secondary font-weight-medium">Total</v-list-item-title>
                <v-list-item-subtitle class="text-right subtitle-1 text--secondary font-weight-medium">{{instance.invoice.total | currency(instance.invoice.currency)}} {{instance.invoice.currency}}</v-list-item-subtitle>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
        <!-- end summary -->
      </template>
    </v-card-text>
  </v-card>
</template>
<script>
import GenericViewMixin from '@/mixins/GenericViewMixin'
export default {
  props: {
    instance: {
      type: Object,
      required: true
    },
    logo: {
      type: String,
      required: false,
      default: () => (null)
    },
    colorBackground: {
      type: String,
      required: false,
      default: () => ('#4051B5')
    },
    colorAsset: {
      type: String,
      required: false,
      default: () => ('#525F7F')
    }
  },
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    method: 0
  }),
  created () {
    this.selectedGateway = this.instance.gateways[0]
  }
}
</script>